<template>
  <div class="goods-list-combox">
    <el-table :data="pageData.items" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="id" label="ID" width="100" />
      <el-table-column prop="title" label="标题" />
      <el-table-column label="状态" width="120">
        <template slot-scope="scope">
          {{goodsConfig.auditStateMap[scope.row.audit_state]['title']}}
        </template>
      </el-table-column>
      <el-table-column prop="username" label="发布人" width="220" />
      <el-table-column prop="ctime" label="时间" width="200" />
      <el-table-column prop="title" label="操作" width="240">
        <template slot-scope="scope">
          <span class="action" v-for="(action,index) in scope.row.actions" :key="'action-' +index" @click="processAction(action, scope.row)">{{goodsConfig['auditActionMap'][action]['title']}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="pageData.totalPage">
      <el-pagination background layout="total, prev, pager, next" :current-page="pageData.page" :page-size="pageData.pageSize" :total="pageData.amount" @current-change="handlePageChange" />
    </div>
    <el-dialog title="修改商品" :visible.sync="showEditDialog" width="50%" :close-on-click-modal="false">
      <el-form :model="formData">
        <el-form-item label="编号" label-width="120px">{{formData.code}}（{{formData.id}}）</el-form-item>
        <el-form-item label="标题" label-width="120px" :rules="[{ required: true, message: '标题不能为空'}]">
          <el-input v-model="formData.goods_title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="类型" label-width="120px" :rules="[{ required: true, message: '类型不能为空'}]">
          <el-input v-model="formData.goods_type" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="价格" label-width="120px" :rules="[{ required: true, message: '价格不能为空'}]">
          <el-input v-model="formData.goods_price" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="成色" label-width="120px" :rules="[{ required: true, message: '成色不能为空'}]">
          <el-input v-model="formData.quality" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述" label-width="120px" :rules="[{ required: true, message: '排序不能为空'}]">
          <el-input type="textarea" v-model="formData.description" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图片" label-width="120px" :rules="[{ required: true, message: 'icon不能为空'}]">
          <div class="image-box">
            <div class="image-item" v-if="formData.goods_imgs" v-for="(image,index) in formData.goods_imgs" :id="index" :key="'index-' + index">
              <el-image
                class="goods-thumb"
                :src="image.url"
                :preview-src-list="prevImages"
                fit="contain"
              />
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import {GoodsRequestUtil} from '../../utils/GoodsRequestUtil'

export default {
  name: 'GoodsListComponent',
  props: {
    pageData: {}
  },
  data () {
    return {
      ids: [],
      formData: {},
      sortedImgs: [],
      prevImages: [],
      images: [],
      showEditDialog: false
    }
  },
  methods: {
    handleSelectionChange (val) {
      let ids = []
      for (let i in val) {
        ids.push(val[i]['id'])
      }
      this.$emit('onSelectChanged', ids)
    },
    handlePageChange (val) {
      this.$emit('onPageChanged', val)
    },
    save () {
      let that = this
      GoodsRequestUtil.saveGoodsInfo({goodsInfo: that.formData, sortedImgs: that.sortedImgs}, function (response) {
        if (response.result) {
          that.showEditDialog = false
          that.sortedImgs = []
          that.formData = {}
          that.$emit('goodsListChanged', that.formData)
        }
      })
    },
    editGoods (data) {
      let that = this
      this.showEditDialog = true
      this.formData = data
      this.prevImages = []
      for (let i in this.formData.goods_imgs) {
        this.prevImages.push(this.formData.goods_imgs[i].url)
      }
      that.images = that.formData.goods_imgs.concat()
      setTimeout(function () {
        let body = document.querySelector('.el-form-item__content div.image-box')
        Sortable.create(body, {
          onEnd ({ newIndex, oldIndex }) {
            const currRow = that.images.splice(oldIndex, 1)[0]
            that.images.splice(newIndex, 0, currRow)
            that.sortedImgs = that.images
            for (let i in that.images) {
              console.log(that.images[i].url)
            }
          }
        })
      }, 1000)
    },
    processAction (action, data) {
      let that = this
      switch (action) {
        case 'EDIT':
          that.editGoods(data)
          break
        case 'VIEW':
          that.$router.push('/goods/detail/' + data.id)
          break
        case 'PASS':
          GoodsRequestUtil.pass({ ids: [data.id] }, function () {
            that.$emit('goodsListChanged', data.id)
          })
          break
        case 'REFUSE':
          GoodsRequestUtil.refuse({ ids: [data.id] }, function () {
            that.$emit('goodsListChanged', data.id)
          })
          break
        case 'DELETE':
          GoodsRequestUtil.remove({ ids: [data.id] }, function () {
            that.$emit('goodsListChanged', data.id)
          })
          break
        default:
          this.$message.error('未知的操作类型')
      }
    }
  }
}
</script>

<style scoped lang="less">
.pagination {
  margin-top: 20px;
  text-align: center;
}

.action {
  color: #3a8ee6;
  padding: 0 5px;

  &:hover {
    cursor: pointer;
  }
}
.image-box{
  .image-item{
    display: inline-block;
  }
}
.goods-thumb {
  width: 130px;
  height: 130px;
  padding: 5px;
  border: solid 1px #ddd;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/goods/GoodsListComponent.vue